import { Component } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { CustomerLogsService } from "./customer-logs.service";

@Component({
  selector: 'app-customer-logs',
  templateUrl: './customer-logs.component.html',
  styleUrl: './customer-logs.component.scss'
})
export class CustomerLogsComponent {

  date: Date | undefined;
  SelectedDate: any;
  currentDate: any;
  email: any;
  customerLogs: any;

  constructor(public toastr: ToastrService, private CustomerLogsService: CustomerLogsService) { }


  ngOnInit(): void {
    this.email = localStorage.getItem("email");
  }

  onDateChange(event: any) {
    if (!this.date) {
      // Handle undefined or null date, reset variables
      this.customerLogs = null; // Clear subscriberMail if date is not selected
      return;
    }
    this.SelectedDate = this.date.toLocaleDateString("es-CL");
    console.log(this.SelectedDate);
    const userEmail = this.email;

  }
}
